function copyToClipboard(text: string): Promise<void> {
  return new Promise((resolve, reject) => {
    // Verifica se o Clipboard API está disponível
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(text).then(resolve).catch(() => {
        // Fallback para execCommand em caso de falha
        fallbackCopy(text) ? resolve() : reject(new Error('Falha ao copiar usando execCommand.'));
      });
    } else {
      // Fallback direto para execCommand se Clipboard API não estiver disponível
      fallbackCopy(text) ? resolve() : reject(new Error('Clipboard API não suportada e falha no fallback.'));
    }
  });
}

function fallbackCopy(text: string): boolean {
  let textarea;
  let result;

  try {
    textarea = document.createElement('textarea');
    textarea.setAttribute('readonly', "true");
    textarea.setAttribute('contenteditable', "true");
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.value = text;

    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();

    const range = document.createRange();
    range.selectNodeContents(textarea);

    const sel = window.getSelection();
    sel?.removeAllRanges();
    sel?.addRange(range);

    textarea.setSelectionRange(0, textarea.value.length);
    result = document.execCommand('copy');
  } catch (error) {
    console.error('Erro ao copiar para a área de transferência:', error);
    result = false;
  } finally {
    if (textarea) {
      document.body.removeChild(textarea);
    }   
  }

  if (!result) {
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
    result = prompt(`Press ${copyHotkey}`, text);

    if (!result) {
      return false;
    }
  }

  return true;
}

export { copyToClipboard };